import { IPlanQualityCategoryRow } from './types'

export interface IPlanQualityScores {
  financial: number | null
  sob: number | null
}

export const getPlanQualityScores = (rows: IPlanQualityCategoryRow[]): IPlanQualityScores => {
  const totalRow = rows.find((row) => row.isTotal)

  return {
    financial: totalRow?.financial.score ?? null,
    sob: totalRow?.sob.score ?? null,
  }
}
